import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: 'auto',
    height: 30,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img
        className={classes.logo}
        src="/gasnet-logo-full.jpg"
        alt="GasNet Logo"
      />
    </div>
  );
};

export default LogoFull;
